module.exports = __webpack_public_path__ + "img/icon_utility.3912bf6f.png";